import { render, staticRenderFns } from "./SearchResultSuggestedKeywords.vue?vue&type=template&id=8aa369d8&"
import script from "./SearchResultSuggestedKeywords.vue?vue&type=script&lang=ts&"
export * from "./SearchResultSuggestedKeywords.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports